<template>
  <svg
    aria-hidden="true"
    style="position: absolute; width: 0px; height: 0px; overflow: hidden"
  >
    <symbol id="cai" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        stroke-linejoin="round"
        stroke-width="1.333"
        stroke="currentColor"
        d="M6.793 9.8v2.4a1.8 1.8 0 0 0 1.8 1.8l2.4-5.4V2H4.021a1.2 1.2 0 0 0-1.2 1.02l-.828 5.4a1.2 1.2 0 0 0 1.2 1.38h3.6Z"
      ></path>
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        stroke-linejoin="round"
        stroke-width="1.333"
        stroke="currentColor"
        fill="currentColor"
        d="M10.993 2h1.602a1.386 1.386 0 0 1 1.398 1.2v4.2c-.094.697-.695 1.28-1.398 1.267h-1.602V2Z"
      ></path>
    </symbol>
    <symbol id="fasong" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-fill="currentColor"
        d="m5.152 9.518-.026-.025L9.682 5.42 3.619 8.037 1.172 5.672a.564.564 0 0 1-.149-.25.596.596 0 0 1 .125-.554.515.515 0 0 1 .239-.15l12.958-3.7a.489.489 0 0 1 .271.002c.09.026.17.077.235.147a.595.595 0 0 1 .13.544l-3.453 12.884a.568.568 0 0 1-.133.241.517.517 0 0 1-.225.143.489.489 0 0 1-.261.007.511.511 0 0 1-.232-.13l-3.352-3.24-2.173 2.326V9.518Z"
        fill="currentColor"
      ></path>
    </symbol>
    <symbol id="shujuyuan" viewBox="0 0 16 16" fill="none">
      <g
        data-follow-stroke="currentColor"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
        clip-path="url(#cb4c3__a)"
      >
        <path
          d="M14.667 3.667v9c0 1.104-2.985 2-6.667 2s-6.667-.896-6.667-2v-9"
        ></path>
        <path
          d="M14.667 9.667c0 1.104-2.985 2-6.667 2s-6.667-.896-6.667-2m13.334-3c0 1.104-2.985 2-6.667 2s-6.667-.896-6.667-2"
        ></path>
        <path
          data-follow-fill="currentColor"
          d="M8 5.333c3.682 0 6.667-.895 6.667-2 0-1.104-2.985-2-6.667-2s-6.667.896-6.667 2c0 1.105 2.985 2 6.667 2Z"
          fill="currentColor"
        ></path>
      </g>
      <defs>
        <clippath id="cb4c3__a">
          <path d="M0 0h16v16H0z" fill="#fff"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="shuaxin" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        d="M14 2.667V8M2 8v5.333M14 8A6 6 0 0 0 3.683 3.833M2 8a6 6 0 0 0 10.167 4.317"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="yijiantousu" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.063 8.273v-5.96h7.875v5.96L8 9.75 4.062 8.273ZM2.75 7.781v-.656l-.583.438.583.218ZM1 8.438V7.125l1.75-1.313V1.876c0-.483.392-.875.875-.875h8.75c.483 0 .875.392.875.875v3.938L15 7.125V14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V8.437Zm12.833-.876-.583-.437v.656l.583-.218Zm-3.208-3.937h-5.25v1.313h5.25V3.625ZM5.375 6.25h3.5v1.313h-3.5V6.25Z"
        fill="currentColor"
      ></path>
    </symbol>
    <symbol id="zan" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        d="M9.2 6.2V3.8A1.8 1.8 0 0 0 7.4 2L5 7.4V14h6.972a1.2 1.2 0 0 0 1.2-1.02L14 7.58a1.2 1.2 0 0 0-1.2-1.38H9.2Z"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linejoin="round"
      ></path>
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        d="M5 7.333H3.398C2.695 7.321 2.094 7.903 2 8.6v4.2A1.386 1.386 0 0 0 3.398 14H5V7.333Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="yuliang" viewBox="0 0 16 16" fill="none">
      <g
        data-follow-fill="currentColor"
        fill="currentColor"
        clip-path="url(#cb4c7__a)"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.5.835c.367 0 .665.298.665.665v12c0 .185.15.335.335.335h11c.185 0 .335-.15.335-.335v-12a.665.665 0 1 1 1.33 0v12c0 .92-.745 1.665-1.665 1.665h-11c-.92 0-1.665-.745-1.665-1.665v-12c0-.367.298-.665.665-.665Z"
        ></path>
        <path
          d="M3 8a4.002 4.002 0 0 1 5 0 4.002 4.002 0 0 0 5 0v5H3V8Z"
        ></path>
      </g>
      <defs>
        <clippath id="cb4c7__a">
          <path d="M0 0h16v16H0z" fill="#fff"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="banben" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#cb550__a)">
        <path
          data-follow-fill="currentColor"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.406 1.569.201 5.046a.74.74 0 0 0 .014 1.03L7.7 14.56a.4.4 0 0 0 .6 0l7.485-8.485a.74.74 0 0 0 .014-1.029L12.594 1.57a.852.852 0 0 0-.627-.269H4.033c-.24 0-.47.098-.627.269Zm1.992 4.4A.8.8 0 1 0 4.202 7.03l3.2 3.6a.8.8 0 0 0 1.196 0l3.2-3.6a.8.8 0 1 0-1.196-1.062L8 8.896 5.398 5.969Z"
          fill="currentColor"
        ></path>
      </g>
      <defs>
        <clippath id="cb550__a">
          <path d="M0 0h16v16H0z" fill="#fff"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="douyin" viewBox="0 0 15 15" fill="none">
      <path
        fill="#333"
        d="M7.808.885a.625.625 0 0 0-.625.625c-.002 1.6-.004 2.968-.004 4.102a.624.624 0 0 0-.475-.255c-.999-.048-1.894.103-2.654.494-.768.393-1.356 1.008-1.77 1.813-.624 1.22-.679 2.81-.055 4.113.644 1.346 1.987 2.338 4.018 2.338 1.004 0 1.804-.244 2.432-.648a3.813 3.813 0 0 0 1.319-1.47c.544-1.047.572-2.126.572-2.343V6.656c.427.208.83.353 1.203.423.27.05.498.089.681.113.169.022.346.04.49.028a.625.625 0 0 0 .575-.623V4.573a.625.625 0 0 0-.55-.62 3.57 3.57 0 0 1-1.077-.283 3.053 3.053 0 0 1-.82-.564c-.265-.264-.408-.536-.41-.807V1.51a.625.625 0 0 0-.626-.625H7.808Zm-1.134 7.69c.207 0 .39-.101.504-.256.001.722.003 1.17.005 1.343a1.22 1.22 0 0 1-.276.744.99.99 0 0 1-.802.372c-.368 0-.629-.156-.81-.37-.195-.231-.278-.51-.278-.682 0-.267.089-.638.461-.92.17-.128.466-.231 1.196-.231Z"
        clip-rule="evenodd"
        fill-rule="evenodd"
        data-follow-fill="#333"
      ></path>
    </symbol>
    <symbol id="xiaohongshu" viewBox="0 0 15 15" fill="none">
      <path
        fill="#F03D3D"
        d="M1.875 1.875c0-.69.56-1.25 1.25-1.25h8.75c.69 0 1.25.56 1.25 1.25v11.25c0 .69-.56 1.25-1.25 1.25h-8.75c-.69 0-1.25-.56-1.25-1.25V1.875Zm4.063 5v-5h5v5a.625.625 0 0 1-1.077.432L8.437 5.819 7.014 7.307a.625.625 0 0 1-1.077-.432Z"
        clip-rule="evenodd"
        fill-rule="evenodd"
        data-follow-fill="#F03D3D"
      ></path>
    </symbol>
    <symbol id="huihua-xian" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        d="M14.667 2H1.333v10h7l3.334 1.667V12h3V2Z"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
      <path
        data-follow-stroke="currentColor"
        d="M4.333 7.667S5.667 9 8 9c2.333 0 3.667-1.333 3.667-1.333"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="jingpinzhuizong" viewBox="0 0 16 16" fill="none">
      <g
        stroke-width="1.333"
        stroke-linejoin="round"
        clip-path="url(#cd0ef__a)"
      >
        <path
          data-follow-stroke="currentColor"
          data-follow-fill="currentColor"
          d="M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334Z"
          fill="currentColor"
          stroke="currentColor"
        ></path>
        <path
          d="M3.667 9.377H5.56l1.513-5.044 1.224 7.334 1.518-3.461 1.155 1.171h1.362"
          stroke="#fff"
          stroke-linecap="round"
        ></path>
      </g>
      <defs>
        <clippath id="cd0ef__a">
          <path d="M0 0h16v16H0z" fill="#fff"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="xiaofeizhedongcha" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        d="M3.19 2.657c.042-.375.33-.657.67-.657h8.28c.34 0 .628.282.67.657l1.185 10.5c.05.448-.265.843-.672.843H2.677c-.407 0-.722-.395-.672-.843l1.184-10.5Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linejoin="round"
      ></path>
      <path
        d="M5 6s.667 1.333 3 1.333S11 6 11 6"
        stroke="#fff"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="toufangfenxi" viewBox="0 0 16 16" fill="none">
      <path
        fill="currentColor"
        d="M8 .8c3.314 0 5.882 2.635 5.882 5.949 0 1.73-.694 3.274-1.828 4.356.01 0-.138.152-.321.343-.26.27-.596.619-.667.72-.2.285-.334.602-.4.95h-5.39a4.896 4.896 0 0 0-.33-.89c-.053-.115-.385-.487-.64-.772-.176-.197-.314-.352-.298-.352-1.148-1.093-1.85-2.658-1.85-4.398C2.158 3.392 4.686.8 8 .8Zm3.572 4.578a.668.668 0 0 0-.944 0L8.7 7.305 6.772 5.378a.668.668 0 0 0-.944 0l-1.5 1.5a.668.668 0 0 0 .944.944L6.3 6.795l1.928 1.927c.26.261.683.261.944 0l2.4-2.4a.668.668 0 0 0 0-.944Zm-.857 9.373v-.9H5.326v.9c0 .317.272.573.585.572h4.218a.586.586 0 0 0 .586-.572Z"
        clip-rule="evenodd"
        fill-rule="evenodd"
        data-follow-fill="currentColor"
      ></path>
    </symbol>
    <symbol id="yingxiaochuangyitansuo" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        d="M14 13V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linejoin="round"
      ></path>
      <path
        d="m8 6.105-.965 1.97-2.193.318L6.43 9.946l-.38 2.16L8 11.065l1.95 1.04-.378-2.16 1.586-1.553-2.18-.318L8 6.105Z"
        fill="#fff"
        stroke="#fff"
        stroke-width="1.333"
        stroke-linejoin="round"
      ></path>
      <path
        d="M6.105 4.21h3.79"
        stroke="#fff"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="shanchu" viewBox="0 0 16 16" fill="none">
      <g
        stroke-width="1.333"
        stroke-linejoin="round"
        clip-path="url(#cd0f3__a)"
      >
        <path
          data-follow-stroke="currentColor"
          data-follow-fill="currentColor"
          d="M3 3.333v11.334h10V3.333H3Z"
          fill="currentColor"
          stroke="currentColor"
        ></path>
        <path
          d="M6.667 6.667V11m2.666-4.333V11"
          stroke="#fff"
          stroke-linecap="round"
        ></path>
        <path
          data-follow-stroke="currentColor"
          d="M1.333 3.333h13.334"
          stroke="currentColor"
          stroke-linecap="round"
        ></path>
        <path
          data-follow-stroke="currentColor"
          data-follow-fill="currentColor"
          d="m5.333 3.333 1.097-2h3.162l1.075 2H5.333Z"
          fill="currentColor"
          stroke="currentColor"
        ></path>
      </g>
      <defs>
        <clippath id="cd0f3__a">
          <path d="M0 0h16v16H0z" fill="#fff"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="tiyanban" viewBox="0 0 40 40" fill="none">
      <mask
        height="32"
        width="36"
        y="4"
        x="2"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
        id="cd0f4__a"
      >
        <path
          fill="#D6E5FF"
          d="M8.942 5.824A4 4 0 0 1 12.3 4h15.4a4 4 0 0 1 3.357 1.824l6.177 9.528a4 4 0 0 1-.535 5.011L22.808 34.19a4 4 0 0 1-5.646-.002L3.296 20.363a4 4 0 0 1-.532-5.009l6.178-9.53Z"
        ></path>
      </mask>
      <g mask="url(#cd0f4__a)">
        <path fill="url(#cd0f4__b)" d="M2 4h36v13H2z"></path>
        <path fill="#BCBCBC" d="M2 17h36v19H2z"></path>
        <path
          fill-opacity=".4"
          fill="#fff"
          d="m20 4 7 13H13l7-13Z"
          opacity=".5"
        ></path>
        <path fill="url(#cd0f4__c)" d="M20 35.5 13 17h14l-7 18.5Z"></path>
      </g>
      <defs>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="17"
          x2="20"
          y1="4"
          x1="20"
          id="cd0f4__b"
        >
          <stop stop-color="#ADADAD"></stop>
          <stop stop-color="#A2A2A2" offset="1"></stop>
        </lineargradient>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="17"
          x2="20"
          y1="35.5"
          x1="20"
          id="cd0f4__c"
        >
          <stop stop-color="#ADADAD"></stop>
          <stop stop-color="#A2A2A2" offset="1"></stop>
        </lineargradient>
      </defs>
    </symbol>
    <symbol id="qingxiangban" viewBox="0 0 40 40" fill="none">
      <mask
        height="32"
        width="36"
        y="4"
        x="2"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
        id="cd0f5__a"
      >
        <path
          fill="#D6E5FF"
          d="M8.942 5.824A4 4 0 0 1 12.3 4h15.4a4 4 0 0 1 3.357 1.824l6.177 9.528a4 4 0 0 1-.535 5.011L22.808 34.19a4 4 0 0 1-5.646-.002L3.296 20.363a4 4 0 0 1-.532-5.009l6.178-9.53Z"
        ></path>
      </mask>
      <g mask="url(#cd0f5__a)">
        <path fill="url(#cd0f5__b)" d="M2 4h36v13H2z"></path>
        <path fill="#ACCBFF" d="M2 17h36v19H2z"></path>
        <path fill="url(#cd0f5__c)" d="m20 4 7 13H13l7-13Z" opacity=".5"></path>
        <path fill="url(#cd0f5__d)" d="M20 35.5 13 17h14l-7 18.5Z"></path>
        <path fill="url(#cd0f5__e)" d="M25 4h4.3L37 17h-4.3L25 4Z"></path>
        <path fill="url(#cd0f5__f)" d="M32.7 17H37L20.5 36h-.3l12.5-19Z"></path>
      </g>
      <defs>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="17"
          x2="20"
          y1="4"
          x1="20"
          id="cd0f5__b"
        >
          <stop stop-color="#6EA4FF"></stop>
          <stop stop-color="#4F8AED" offset="1"></stop>
        </lineargradient>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="17"
          x2="20"
          y1="4"
          x1="20"
          id="cd0f5__c"
        >
          <stop stop-color="#DCE9FF"></stop>
          <stop stop-color="#ACCBFF" offset="1"></stop>
        </lineargradient>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="17"
          x2="20"
          y1="35.5"
          x1="20"
          id="cd0f5__d"
        >
          <stop stop-color="#6EA4FF"></stop>
          <stop stop-color="#4B88EF" offset="1"></stop>
        </lineargradient>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="11.73"
          x2="30.132"
          y1="10"
          x1="33.15"
          id="cd0f5__e"
        >
          <stop stop-opacity=".6" stop-color="#fff"></stop>
          <stop stop-opacity="0" stop-color="#fff" offset="1"></stop>
        </lineargradient>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="20"
          x2="30"
          y1="21.5"
          x1="32.5"
          id="cd0f5__f"
        >
          <stop stop-opacity=".6" stop-color="#fff"></stop>
          <stop stop-opacity="0" stop-color="#fff" offset="1"></stop>
        </lineargradient>
      </defs>
    </symbol>
    <symbol id="haohuaban" viewBox="0 0 40 40" fill="none">
      <mask
        height="32"
        width="36"
        y="4"
        x="2"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
        id="cd0f6__a"
      >
        <path
          fill="#D6E5FF"
          d="M8.942 5.824A4 4 0 0 1 12.3 4h15.4a4 4 0 0 1 3.357 1.824l6.177 9.528a4 4 0 0 1-.535 5.011L22.808 34.19a4 4 0 0 1-5.646-.002L3.296 20.363a4 4 0 0 1-.532-5.009l6.178-9.53Z"
        ></path>
      </mask>
      <g mask="url(#cd0f6__a)">
        <path fill="url(#cd0f6__b)" d="M2 4h36v13H2z"></path>
        <path fill="#E3AE61" d="M2 17h36v19H2z"></path>
        <path fill="url(#cd0f6__c)" d="m20 4 6 13H14l6-13Z" opacity=".5"></path>
        <path fill="url(#cd0f6__d)" d="m6 17 5-13h9L6 17Z" opacity=".5"></path>
        <path fill="url(#cd0f6__e)" d="M34 17 20 4h9l5 13Z" opacity=".5"></path>
        <path
          fill="url(#cd0f6__f)"
          d="M20 35.5 26 17h8L20 35.5Z"
          opacity=".5"
        ></path>
        <path
          fill="url(#cd0f6__g)"
          d="M20 35.5 6 17h8l6 18.5Z"
          opacity=".5"
        ></path>
        <path fill="url(#cd0f6__h)" d="M27 4h2.3L37 17h-2.3L27 4Z"></path>
        <path fill="url(#cd0f6__i)" d="M33.7 17H37L20.5 36h-.3l13.5-19Z"></path>
      </g>
      <defs>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="17"
          x2="20"
          y1="4"
          x1="20"
          id="cd0f6__b"
        >
          <stop stop-color="#EBBB75"></stop>
          <stop stop-color="#E5B062" offset="1"></stop>
        </lineargradient>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="4"
          x2="23.5"
          y1="17"
          x1="23.5"
          id="cd0f6__c"
        >
          <stop stop-color="#fff"></stop>
          <stop stop-opacity=".2" stop-color="#fff" offset="1"></stop>
        </lineargradient>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="4"
          x2="14.5"
          y1="17"
          x1="14.5"
          id="cd0f6__d"
        >
          <stop stop-opacity=".2" stop-color="#fff"></stop>
          <stop stop-color="#fff" offset="1"></stop>
        </lineargradient>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="4"
          x2="25.5"
          y1="17"
          x1="25.5"
          id="cd0f6__e"
        >
          <stop stop-opacity=".2" stop-color="#fff"></stop>
          <stop stop-color="#fff" offset="1"></stop>
        </lineargradient>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="17"
          x2="34"
          y1="35.5"
          x1="34"
          id="cd0f6__f"
        >
          <stop stop-opacity=".4" stop-color="#fff"></stop>
          <stop stop-color="#fff" offset="1"></stop>
        </lineargradient>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="17"
          x2="20"
          y1="35.5"
          x1="20"
          id="cd0f6__g"
        >
          <stop stop-opacity=".4" stop-color="#fff"></stop>
          <stop stop-color="#fff" offset="1"></stop>
        </lineargradient>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="11.157"
          x2="31.088"
          y1="10"
          x1="33.15"
          id="cd0f6__h"
        >
          <stop stop-opacity=".6" stop-color="#FFFCF5"></stop>
          <stop stop-opacity="0" stop-color="#FFE1A7" offset="1"></stop>
        </lineargradient>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="24.462"
          x2="28.214"
          y1="25.769"
          x1="30.327"
          id="cd0f6__i"
        >
          <stop stop-opacity=".6" stop-color="#FFF8EB"></stop>
          <stop stop-opacity="0" stop-color="#FFE1A7" offset="1"></stop>
        </lineargradient>
      </defs>
    </symbol>
    <symbol
      id="changyongcaozuo-chenggong-shixin"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#cd6a3__a)">
        <path
          data-follow-fill="currentColor"
          fill="currentColor"
          d="M10.807 14.777A7.31 7.31 0 0 1 8 15.333a7.31 7.31 0 0 1-5.185-2.148A7.31 7.31 0 0 1 .667 8a7.31 7.31 0 0 1 2.148-5.185A7.31 7.31 0 0 1 8 .667a7.31 7.31 0 0 1 5.185 2.148A7.312 7.312 0 0 1 15.333 8a7.31 7.31 0 0 1-2.148 5.185 7.312 7.312 0 0 1-2.378 1.592Zm.998-8.306a.667.667 0 1 0-.943-.942L7.333 9.057 5.805 7.53a.667.667 0 0 0-.943.942l2 2c.26.26.682.26.943 0l4-4Z"
          clip-rule="evenodd"
          fill-rule="evenodd"
        ></path>
      </g>
      <defs>
        <clippath id="cd6a3__a">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="preview-open" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-width="4"
        stroke="currentColor"
        d="M24 36c11.046 0 20-12 20-12s-8.954-12-20-12S4 24 4 24s8.954 12 20 12Z"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-width="4"
        stroke="currentColor"
        d="M24 29a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
        data-follow-stroke="currentColor"
      ></path>
    </symbol>
    <symbol id="preview-close" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M6 16c.635 1.22 1.596 2.35 2.823 3.355C12.26 22.173 17.779 24 24 24s11.739-1.827 15.177-4.645C40.404 18.35 41.365 17.22 42 16m-13.023 8 2.071 7.727m6.305-10.373 5.657 5.656M5 27.01l5.657-5.657m6.271 10.375L18.998 24"
        data-follow-stroke="currentColor"
      ></path>
    </symbol>
    <symbol id="corner-down-left" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="m16 18-8 8 8 8"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M40 10v13a3 3 0 0 1-3 3H8"
        data-follow-stroke="currentColor"
      ></path>
    </symbol>
    <symbol id="dianji" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#d16a9__a)">
        <path
          stroke-width="1.333"
          stroke="#333"
          fill="#fff"
          d="M12 8a4 4 0 0 0-8 0v2.667a4 4 0 0 0 8 0V8Z"
          data-follow-stroke="#333"
        ></path>
        <path
          stroke-width="1.333"
          stroke="#333"
          fill="#307DFF"
          d="M4 8a4 4 0 0 1 4-4v4.333H4V8Z"
          data-follow-stroke="#333"
        ></path>
        <path
          stroke-width="1.333"
          stroke="#333"
          d="M4 8a4 4 0 0 1 8 0v.333H4V8Z"
          data-follow-stroke="#333"
        ></path>
        <path
          stroke-width="1.33"
          stroke="#333"
          d="M7.965 4v4"
          data-follow-stroke="#333"
        ></path>
        <path
          fill="#333"
          d="M2.62 6.905.69 6.387l.344-1.284 1.932.517-.344 1.285Zm.858-2.552L2.064 2.939l.94-.94 1.414 1.413-.94.94ZM5.686 2.9 5.168.966 6.453.623l.518 1.932-1.285.344Z"
          clip-rule="evenodd"
          fill-rule="evenodd"
        ></path>
      </g>
      <defs>
        <clippath id="d16a9__a">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="link-one" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="m26.24 16.373-9.14-9.14c-2.661-2.661-7.035-2.603-9.768.131-2.734 2.734-2.793 7.107-.131 9.768l7.935 7.936m17.767-2.065 7.935 7.935c2.661 2.662 2.603 7.035-.13 9.769-2.735 2.734-7.108 2.792-9.77.13l-9.14-9.14"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M26.11 26.142c2.733-2.734 2.792-7.108.13-9.769m-4.441 5.425c-2.734 2.734-2.792 7.108-.131 9.769"
        data-follow-stroke="currentColor"
      ></path>
    </symbol>
    <symbol id="shengyucishu" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        d="M2 4.5a2.5 2.5 0 0 1 5 0V7H4.5A2.5 2.5 0 0 1 2 4.5Zm12 7a2.5 2.5 0 0 1-5 0V9h2.5a2.5 2.5 0 0 1 2.5 2.5ZM4.5 14a2.5 2.5 0 0 1 0-5H7v2.5A2.5 2.5 0 0 1 4.5 14Zm7-12a2.5 2.5 0 0 1 0 5H9V4.5A2.5 2.5 0 0 1 11.5 2Z"
        stroke="currentColor"
      ></path>
    </symbol>
    <symbol id="c-headset-one" viewBox="0 0 48 48" fill="none">
      <path d="M0 0h48v48H0z" fill="#fff" fill-opacity=".01"></path>
      <path
        data-follow-fill="currentColor"
        d="M36 32a8 8 0 1 0 0-16"
        fill="currentColor"
      ></path>
      <path
        data-follow-stroke="currentColor"
        d="M36 32a8 8 0 1 0 0-16"
        stroke="currentColor"
        stroke-width="4"
        stroke-linejoin="round"
      ></path>
      <path
        data-follow-fill="currentColor"
        d="M12 16a8 8 0 1 0 0 16"
        fill="currentColor"
      ></path>
      <path
        data-follow-stroke="currentColor"
        d="M12 16a8 8 0 1 0 0 16"
        stroke="currentColor"
        stroke-width="4"
        stroke-linejoin="round"
      ></path>
      <path
        data-follow-stroke="currentColor"
        d="M12 32V16c0-6.627 5.373-12 12-12s12 5.373 12 12v16c0 6.627-5.373 12-12 12"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="c-close" viewBox="0 0 48 48" fill="none">
      <path d="M0 0h48v48H0z" fill="#fff" fill-opacity=".01"></path>
      <path
        data-follow-stroke="currentColor"
        d="m8 8 32 32M8 40 40 8"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="Frame" viewBox="0 0 14 14" fill="none">
      <g
        clip-path="url(#d27f6__a)"
        stroke-linejoin="round"
        stroke-width="1.167"
      >
        <path
          stroke="#F03D3D"
          fill="#F03D3D"
          d="M7 12.833A5.833 5.833 0 1 0 7 1.167a5.833 5.833 0 0 0 0 11.666Z"
        ></path>
        <path stroke-linecap="round" stroke="#fff" d="M4.667 7h4.666"></path>
      </g>
      <defs>
        <clippath id="d27f6__a">
          <path fill="#fff" d="M0 0h14v14H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="c-left" viewBox="0 0 48 48" fill="none">
      <path
        data-follow-fill="currentColor"
        fill-opacity=".01"
        fill="currentColor"
        d="M0 0h48v48H0z"
      ></path>
      <path
        data-follow-stroke="currentColor"
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M31 36 19 24l12-12"
      ></path>
    </symbol>
    <symbol id="c-success" viewBox="0 0 48 48" fill="none">
      <path
        data-follow-fill="currentColor"
        d="M0 0h48v48H0z"
        fill="currentColor"
        fill-opacity=".01"
      ></path>
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        d="M24 44a19.937 19.937 0 0 0 14.142-5.858A19.937 19.937 0 0 0 44 24a19.938 19.938 0 0 0-5.858-14.142A19.937 19.937 0 0 0 24 4 19.938 19.938 0 0 0 9.858 9.858 19.938 19.938 0 0 0 4 24a19.937 19.937 0 0 0 5.858 14.142A19.938 19.938 0 0 0 24 44z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="4"
        stroke-linejoin="round"
      ></path>
      <path
        d="m16 24 6 6 12-12"
        stroke="#FFF"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="expand-text-input" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M22 42H6V26M26 6h16v16"
        data-follow-stroke="currentColor"
      ></path>
    </symbol>
    <symbol id="collapse-text-input" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M44 20H28V4M4 28h16v16"
        data-follow-stroke="currentColor"
      ></path>
    </symbol>
    <symbol id="userIcon" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 4.333a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm1.238 4.334h3.524c.723 0 1.305 0 1.777.038.486.04.913.124 1.308.325.627.32 1.137.83 1.457 1.457.2.395.285.821.324 1.307.039.472.039 1.055.039 1.777V14a.667.667 0 0 1-.667.667H2A.667.667 0 0 1 1.333 14v-.428c0-.723 0-1.306.039-1.778.04-.486.124-.912.325-1.307.32-.627.83-1.137 1.457-1.457.394-.201.821-.285 1.307-.325.472-.038 1.055-.038 1.777-.038Z"
        fill="currentColor"
      ></path>
    </symbol>
    <symbol id="goumaixufei-mian" viewBox="0 0 18 18" fill="none">
      <path
        data-follow-fill="currentColor"
        fill="currentColor"
        d="M1.19 2.69a1.5 1.5 0 0 1 1.06-.44h13.5a1.5 1.5 0 0 1 1.5 1.5v10.5a1.5 1.5 0 0 1-1.5 1.5H2.25a1.5 1.5 0 0 1-1.5-1.5V3.75c0-.398.158-.78.44-1.06Z"
        clip-rule="evenodd"
        fill-rule="evenodd"
      ></path>
      <path
        fill="#fff"
        d="M17.25 5.25v1.5H.75v-1.5c5.5-.01 11 0 16.5 0ZM9.375 12a.75.75 0 0 1 .75-.75H13.5a.75.75 0 0 1 0 1.5h-3.375a.75.75 0 0 1-.75-.75Z"
        clip-rule="evenodd"
        fill-rule="evenodd"
      ></path>
    </symbol>
    <symbol id="logout" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M23.992 6H6v36h18m9-9 9-9-9-9m-17 8.992h26"
        data-follow-stroke="currentColor"
      ></path>
    </symbol>
    <symbol id="c-info" viewBox="0 0 48 48" fill="none">
      <path d="M0 0h48v48H0z" fill="#fff" fill-opacity=".01"></path>
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        d="M24 44a19.937 19.937 0 0 0 14.142-5.858A19.937 19.937 0 0 0 44 24a19.938 19.938 0 0 0-5.858-14.142A19.937 19.937 0 0 0 24 4 19.938 19.938 0 0 0 9.858 9.858 19.938 19.938 0 0 0 4 24a19.937 19.937 0 0 0 5.858 14.142A19.938 19.938 0 0 0 24 44z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="4"
        stroke-linejoin="round"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 11a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5z"
        fill="#FFF"
      ></path>
      <path
        d="M24.5 34V20h-2M21 34h7"
        stroke="#FFF"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="c-sanjiao-xia" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.384 10.54a.5.5 0 0 1-.768 0L3.683 5.82A.5.5 0 0 1 4.068 5h7.864a.5.5 0 0 1 .385.82l-3.933 4.72z"
        fill="currentColor"
      ></path>
    </symbol>
    <symbol id="agreement" viewBox="0 0 48 48" fill="none">
      <rect
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        rx="2"
        height="40"
        width="32"
        y="4"
        x="8"
        data-follow-stroke="currentColor"
      ></rect>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        fill="currentColor"
        d="M16 4h9v16l-4.5-4-4.5 4V4Z"
        data-follow-fill="currentColor"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M16 28h10m-10 6h16"
        data-follow-stroke="currentColor"
      ></path>
    </symbol>
    <symbol id="table-file" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-width="4"
        stroke="currentColor"
        d="M42 6H6a2 2 0 0 0-2 2v32a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Z"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M4 18h40m-26.5 0v24m13-24v24M4 30h40m0-22v32a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8"
        data-follow-stroke="currentColor"
      ></path>
    </symbol>
    <symbol id="log" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-width="4"
        stroke="currentColor"
        fill="currentColor"
        d="M13 10h28v34H13z"
        data-follow-fill="currentColor"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M35 10V4H8a1 1 0 0 0-1 1v33h6"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="#FFF"
        d="M21 22h12m-12 8h12"
      ></path>
    </symbol>
    <symbol id="carousel-video" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        fill="currentColor"
        d="M11 7h26v34H11z"
        data-follow-fill="currentColor"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M4 11h7v26H4zm33 0h7v26h-7z"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="#FFF"
        fill="#FFF"
        d="m22 20 6 4-6 4v-8Z"
      ></path>
    </symbol>
    <symbol id="tiwen-mian" viewBox="0 0 16 16" fill="none">
      <path
        fill="url(#d8ac8__a)"
        d="M14.667 4a2 2 0 0 0-2-2H3.333a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h5l3.334 1.667V13h1a2 2 0 0 0 2-2V4Z"
      ></path>
      <path
        fill="#fff"
        d="M6 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clip-rule="evenodd"
        fill-rule="evenodd"
        data-follow-fill="#fff"
      ></path>
      <defs>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="13"
          x2="4"
          y1="1.5"
          x1="12.5"
          id="d8ac8__a"
        >
          <stop stop-color="#AA3DFF"></stop>
          <stop stop-color="#2F88FF" offset="1"></stop>
        </lineargradient>
      </defs>
    </symbol>
    <symbol id="arrow-right" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M42 24H6m24-12 12 12-12 12"
        data-follow-stroke="currentColor"
      ></path>
    </symbol>
    <symbol id="jiagequjiantongji" viewBox="0 0 16 16" fill="none">
      <circle
        stroke-width="1.33"
        stroke="#784FEC"
        fill="#784FEC"
        r="4.5"
        cy="8"
        cx="5.5"
        opacity=".5"
        data-follow-fill="#784FEC"
        data-follow-stroke="#784FEC"
      ></circle>
      <circle
        stroke-width="1.33"
        stroke="#784FEC"
        fill="#784FEC"
        r="4.5"
        cy="8"
        cx="10.5"
        opacity=".5"
        data-follow-fill="#784FEC"
        data-follow-stroke="#784FEC"
      ></circle>
      <path
        fill="#784FEC"
        d="M8 11.742A4.496 4.496 0 0 0 10 8c0-1.56-.794-2.935-2-3.742A4.496 4.496 0 0 0 6 8c0 1.56.794 2.935 2 3.742Z"
        clip-rule="evenodd"
        fill-rule="evenodd"
        data-follow-fill="#784FEC"
      ></path>
      <path
        fill="#784FEC"
        d="m8 11.742-.37.553.37.248.37-.248-.37-.553Zm0-7.484.37-.553L8 3.458l-.37.247.37.553ZM9.335 8a3.83 3.83 0 0 1-1.705 3.19l.74 1.105A5.16 5.16 0 0 0 10.665 8h-1.33ZM7.63 4.81A3.83 3.83 0 0 1 9.335 8h1.33A5.16 5.16 0 0 0 8.37 3.705L7.63 4.81ZM6.665 8c0-1.329.675-2.5 1.705-3.19l-.74-1.105A5.16 5.16 0 0 0 5.335 8h1.33Zm1.705 3.19A3.83 3.83 0 0 1 6.665 8h-1.33a5.16 5.16 0 0 0 2.295 4.295l.74-1.105Z"
        data-follow-fill="#784FEC"
      ></path>
    </symbol>
    <symbol id="baowenfenxi" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="#F57329"
        data-follow-fill="#F57329"
        stroke-linejoin="round"
        stroke-width="1.333"
        stroke="#F57329"
        fill="#F57329"
        d="M2.667 2c0-.368.298-.667.666-.667h9.334c.368 0 .666.299.666.667v12a.667.667 0 0 1-.666.667H3.333A.667.667 0 0 1 2.667 14V2Z"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#fff"
        d="M5.333 1.333v13.334M8 4h2.667M8 6.667h2.667"
      ></path>
      <path
        data-follow-stroke="#F57329"
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#F57329"
        d="M3.333 1.333h4m-4 13.333h4"
      ></path>
    </symbol>
    <symbol id="reduqushi" viewBox="0 0 16 16" fill="none">
      <path
        stroke-linejoin="round"
        stroke-width="1.333"
        stroke="#F65454"
        fill="#F75454"
        d="M8 14.667c2.745 0 5-2.175 5-4.967 0-.686-.035-1.42-.415-2.563-.38-1.142-.456-1.289-.858-1.994-.172 1.439-1.09 2.039-1.323 2.218 0-.186-.556-2.249-1.398-3.483-.827-1.211-1.952-2.006-2.61-2.545 0 1.024-.289 2.545-.7 3.32-.413.775-.49.804-1.005 1.38-.515.577-.751.756-1.182 1.456C3.08 8.189 3 9.12 3 9.806c0 2.792 2.255 4.86 5 4.86Z"
        data-follow-fill="#F75454"
        data-follow-stroke="#F65454"
      ></path>
    </symbol>
    <symbol id="xiaofeizhepingjia" viewBox="0 0 16 16" fill="none">
      <g
        data-follow-stroke="#43E2A9"
        clip-path="url(#d9cab__a)"
        stroke="#43E2A9"
      >
        <path
          data-follow-fill="#43E2A9"
          fill="#43E2A9"
          d="M12.625 8.608c1.258-2.178.484-4.827-.09-5.158-.318-.183-1.273-.064-2.276.44-.61-1.51-1.787-2.515-2.268-2.515-.482 0-1.66 1.005-2.272 2.516-1.003-.505-1.958-.624-2.275-.441-.575.333-1.347 2.98-.09 5.158.998 1.73 2.794 2.884 3.971 3.014v2.376a.664.664 0 1 0 1.328 0v-2.376c1.177-.128 2.973-1.284 3.972-3.014Z"
        ></path>
        <path
          stroke-linecap="round"
          stroke-width="1.33"
          d="M1.5 12C4 12.5 5 14 5 14m9.5-2c-2.5.5-3.5 2-3.5 2"
        ></path>
      </g>
      <defs>
        <clippath id="d9cab__a">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="neirongguanjianci" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#d9cac__a)" fill="#3067F2">
        <path
          d="M9 1.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-2ZM15 7a.5.5 0 0 0-.5-.5h-7A.5.5 0 0 0 7 7v2a.5.5 0 0 0 .5.5h7A.5.5 0 0 0 15 9V7ZM1 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2Zm14-11a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2ZM1 7a.5.5 0 0 1 .5-.5h2A.5.5 0 0 1 4 7v2a.5.5 0 0 1-.5.5h-2A.5.5 0 0 1 1 9V7Zm14 5.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2Z"
          clip-rule="evenodd"
          fill-rule="evenodd"
        ></path>
        <path
          d="M1.5 1.665h7V.335h-7v1.33ZM1.665 3.5v-2H.335v2h1.33ZM8.5 3.335h-7v1.33h7v-1.33ZM8.335 1.5v2h1.33v-2h-1.33ZM7.5 7.165h7v-1.33h-7v1.33ZM7.665 9V7h-1.33v2h1.33Zm6.835-.165h-7v1.33h7v-1.33ZM14.335 7v2h1.33V7h-1.33ZM8.5 11.335h-7v1.33h7v-1.33ZM9.665 14.5v-2h-1.33v2h1.33ZM1.5 15.665h7v-1.33h-7v1.33ZM.335 12.5v2h1.33v-2H.335ZM12.5 1.665h2V.335h-2v1.33Zm.165 1.835v-2h-1.33v2h1.33Zm1.835-.165h-2v1.33h2v-1.33ZM14.335 1.5v2h1.33v-2h-1.33ZM3.5 5.835h-2v1.33h2v-1.33ZM4.665 9V7h-1.33v2h1.33ZM1.5 10.165h2v-1.33h-2v1.33ZM.335 7v2h1.33V7H.335ZM12.5 12.665h2v-1.33h-2v1.33Zm.165 1.835v-2h-1.33v2h1.33Zm1.835-.165h-2v1.33h2v-1.33Zm-.165-1.835v2h1.33v-2h-1.33Zm.165 3.165c.643 0 1.165-.522 1.165-1.165h-1.33c0-.091.074-.165.165-.165v1.33ZM11.335 14.5c0 .643.522 1.165 1.165 1.165v-1.33c.091 0 .165.074.165.165h-1.33Zm3.165-1.835a.165.165 0 0 1-.165-.165h1.33c0-.643-.522-1.165-1.165-1.165v1.33Zm-2-1.33c-.643 0-1.165.522-1.165 1.165h1.33a.165.165 0 0 1-.165.165v-1.33Zm-11-2.5c.091 0 .165.074.165.165H.335c0 .643.522 1.165 1.165 1.165v-1.33ZM3.335 9c0-.091.074-.165.165-.165v1.33c.643 0 1.165-.522 1.165-1.165h-1.33ZM1.5 5.835C.857 5.835.335 6.357.335 7h1.33a.165.165 0 0 1-.165.165v-1.33Zm2 1.33A.165.165 0 0 1 3.335 7h1.33c0-.643-.522-1.165-1.165-1.165v1.33Zm11-2.5c.643 0 1.165-.522 1.165-1.165h-1.33c0-.091.074-.165.165-.165v1.33ZM11.335 3.5c0 .643.522 1.165 1.165 1.165v-1.33c.091 0 .165.074.165.165h-1.33ZM14.5 1.665a.165.165 0 0 1-.165-.165h1.33c0-.643-.522-1.165-1.165-1.165v1.33Zm-2-1.33c-.643 0-1.165.522-1.165 1.165h1.33a.165.165 0 0 1-.165.165V.335Zm-11 14c.091 0 .165.074.165.165H.335c0 .643.522 1.165 1.165 1.165v-1.33Zm6.835.165c0-.091.074-.165.165-.165v1.33c.643 0 1.165-.522 1.165-1.165h-1.33ZM1.5 11.335c-.643 0-1.165.522-1.165 1.165h1.33a.165.165 0 0 1-.165.165v-1.33Zm7 1.33a.165.165 0 0 1-.165-.165h1.33c0-.643-.522-1.165-1.165-1.165v1.33Zm6-2.5c.643 0 1.165-.522 1.165-1.165h-1.33c0-.091.074-.165.165-.165v1.33ZM6.335 9c0 .643.522 1.165 1.165 1.165v-1.33c.091 0 .165.074.165.165h-1.33ZM14.5 7.165A.165.165 0 0 1 14.335 7h1.33c0-.643-.522-1.165-1.165-1.165v1.33Zm-7-1.33c-.643 0-1.165.522-1.165 1.165h1.33a.165.165 0 0 1-.165.165v-1.33Zm1-1.17c.643 0 1.165-.522 1.165-1.165h-1.33c0-.091.074-.165.165-.165v1.33ZM.335 3.5c0 .643.522 1.165 1.165 1.165v-1.33c.091 0 .165.074.165.165H.335ZM8.5 1.665a.165.165 0 0 1-.165-.165h1.33C9.665.857 9.143.335 8.5.335v1.33Zm-7-1.33C.857.335.335.857.335 1.5h1.33a.165.165 0 0 1-.165.165V.335Z"
        ></path>
      </g>
      <defs>
        <clippath id="d9cac__a">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="toufangdarenfenxi" viewBox="0 0 16 16" fill="none">
      <path
        stroke-width="1.33"
        stroke="#FCB327"
        fill="#FCB327"
        d="M2 2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v11.613a1 1 0 0 1-1.316.948l-4.368-1.456a1 1 0 0 0-.632 0l-4.368 1.456A1 1 0 0 1 2 13.613V2Z"
        data-follow-stroke="#FCB327"
      ></path>
      <path
        fill="#fff"
        d="M7.592 3.074a.5.5 0 0 1 .816 0l1.29 1.817a.5.5 0 0 0 .258.188l2.127.666a.5.5 0 0 1 .252.775l-1.329 1.789a.5.5 0 0 0-.099.303l.024 2.23a.5.5 0 0 1-.66.478l-2.111-.71a.5.5 0 0 0-.32 0l-2.112.711a.5.5 0 0 1-.66-.479l.025-2.229a.5.5 0 0 0-.099-.303l-1.33-1.79a.5.5 0 0 1 .253-.775l2.127-.666a.5.5 0 0 0 .258-.188l1.29-1.817Z"
      ></path>
    </symbol>
    <symbol id="jiagepianhaofenxi" viewBox="0 0 16 16" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#F840AE"
        fill="#F840AE"
        d="M4.85 2C2.724 2 1 3.865 1 6.166 1 10.332 5.55 14.119 8 15c2.45-.881 7-4.668 7-8.834C15 3.866 13.276 2 11.15 2 9.848 2 8.697 2.7 8 3.77 7.303 2.7 6.152 2 4.85 2Z"
        data-follow-fill="#F840AE"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#fff"
        d="M11 5 8 8M5 5l3 3m-2.333.833h4.666m-4.666 2h4.666M8.067 8.667v3.666"
      ></path>
    </symbol>
    <symbol id="xiaofeizhehuaxiang" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#d9caf__a)" fill="#1DD9E6">
        <path
          d="M6 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM5 9a4 4 0 0 0-4 4v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a4 4 0 0 0-4-4H5Z"
          clip-rule="evenodd"
          fill-rule="evenodd"
        ></path>
        <path
          d="M8.335 4A2.335 2.335 0 0 1 6 6.335v1.33A3.665 3.665 0 0 0 9.665 4h-1.33ZM6 1.665A2.335 2.335 0 0 1 8.335 4h1.33A3.665 3.665 0 0 0 6 .335v1.33ZM3.665 4A2.335 2.335 0 0 1 6 1.665V.335A3.665 3.665 0 0 0 2.335 4h1.33ZM6 6.335A2.335 2.335 0 0 1 3.665 4h-1.33A3.665 3.665 0 0 0 6 7.665v-1.33ZM1.665 13A3.335 3.335 0 0 1 5 9.665v-1.33A4.665 4.665 0 0 0 .335 13h1.33Zm0 1v-1H.335v1h1.33Zm.335.335A.335.335 0 0 1 1.665 14H.335c0 .92.745 1.665 1.665 1.665v-1.33Zm8 0H2v1.33h8v-1.33Zm.335-.335c0 .185-.15.335-.335.335v1.33c.92 0 1.665-.745 1.665-1.665h-1.33Zm0-1v1h1.33v-1h-1.33ZM7 9.665A3.335 3.335 0 0 1 10.335 13h1.33A4.665 4.665 0 0 0 7 8.335v1.33Zm-2 0h2v-1.33H5v1.33Z"
        ></path>
        <path
          d="M6.335 4a3.665 3.665 0 1 1 7.33 0 3.665 3.665 0 0 1-7.33 0Zm-2 9A4.665 4.665 0 0 1 9 8.335h2A4.665 4.665 0 0 1 15.665 13v1c0 .92-.745 1.665-1.665 1.665H6c-.92 0-1.665-.745-1.665-1.665v-1Z"
          clip-rule="evenodd"
          fill-rule="evenodd"
          opacity=".3"
        ></path>
      </g>
      <defs>
        <clippath id="d9caf__a">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="xiaofeijueceyaosu" viewBox="0 0 16 16" fill="none">
      <path
        fill="#515FDE"
        d="M12.763 5.408a.744.744 0 0 0 0-1.051L9.617 1.205a.74.74 0 0 0-1.253.53.744.744 0 0 0 .205.52l3.145 3.153a.74.74 0 0 0 1.049 0ZM9.1 9.093a.751.751 0 0 0-1.064 0l-.508.51a.752.752 0 0 1-1.065 0L4.381 7.518a.754.754 0 0 1 0-1.066l3.132-3.137a.751.751 0 0 1 1.063 0L10.658 5.4a.755.755 0 0 1 0 1.067l-.509.51a.754.754 0 0 0 0 1.066l4.646 4.655a.744.744 0 0 1-1.048 1.05L9.1 9.094ZM2.276 7.51a.74.74 0 0 1 1.05 0l3.145 3.152a.744.744 0 0 1-.808 1.22.743.743 0 0 1-.24-.17L2.275 8.56a.744.744 0 0 1 0-1.05ZM1 14.246a.754.754 0 0 1 .752-.753h7.522a.752.752 0 0 1 .288 1.45.752.752 0 0 1-.288.057H1.752A.751.751 0 0 1 1 14.246Z"
        data-follow-fill="#515FDE"
      ></path>
    </symbol>
    <symbol id="xiaofeizhedongcha-9mh76e86" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 13.667c3.314 0 6-2.774 6-4.667 0-1.893-2.686-4.667-6-4.667S2 7.11 2 9c0 1.89 2.686 4.667 6 4.667Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linejoin="round"
      ></path>
      <path
        d="M8 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        fill="#fff"
        stroke="#fff"
        stroke-width="1.333"
        stroke-linejoin="round"
      ></path>
      <path
        data-follow-stroke="currentColor"
        d="m4.421 3.755.865 1.207m6.589-1.059L11.01 5.11M8.003 2.333v2"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linecap="round"
      ></path>
    </symbol>
    <symbol id="darentoufang" viewBox="0 0 16 16" fill="none">
      <path
        fill="#F03D3D"
        d="M2 3a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l3.414 3.414a1 1 0 0 1 .293.707V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3Z"
      ></path>
      <path
        fill="#fff"
        d="M7.432 11H5.56l-.112-1.272h-1.48L3.4 11h-.776l2.36-5.08H6.88L7.432 11Zm-3.2-1.856h1.16l-.184-2.176-.976 2.176ZM7.813 11l1.08-5.08h2.151c.331 0 .62.035.864.104.251.064.457.173.617.328.165.155.287.357.367.608.086.25.129.557.129.92 0 .39-.051.77-.153 1.144a2.691 2.691 0 0 1-.488 1c-.229.293-.53.53-.904.712-.368.176-.824.264-1.368.264H7.813Zm2.192-.56c.175 0 .33-.072.463-.216.14-.15.257-.336.352-.56.102-.23.184-.48.248-.752.07-.277.123-.544.16-.8a7.97 7.97 0 0 0 .088-.688 4.73 4.73 0 0 0 .032-.432c0-.165-.034-.293-.104-.384-.063-.096-.178-.144-.344-.144h-.383L9.66 10.44h.344Z"
      ></path>
    </symbol>
    <symbol id="toufanghoufupan" viewBox="0 0 16 16" fill="none">
      <path
        stroke-linecap="round"
        stroke-width="1.33"
        stroke="#784FEC"
        d="M2 2h12m-6.6 8.3-3 4m4.2-4 3 4"
      ></path>
      <rect
        fill="#784FEC"
        rx="1"
        height="11"
        width="12"
        y="2"
        x="2"
        data-follow-fill="#784FEC"
      ></rect>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.33"
        stroke="#fff"
        d="m4 10 3-3.5L10 9l2-3"
      ></path>
    </symbol>
    <symbol id="huatiguanjianci" viewBox="0 0 16 16" fill="none">
      <g
        stroke-width="1.333"
        stroke-linejoin="round"
        clip-path="url(#db1b6__a)"
      >
        <path
          data-follow-stroke="currentColor"
          data-follow-fill="currentColor"
          d="M8 14.667a6.667 6.667 0 1 0-5.544-2.963c.081.121-.07.886-.456 2.296 1.41-.385 2.175-.537 2.296-.456A6.65 6.65 0 0 0 8 14.667Z"
          fill="currentColor"
          stroke="currentColor"
        ></path>
        <path
          d="M5.535 6.607h5.593M7.282 5.246l-.971 5.508m3.305-5.508-.971 5.508M4.868 9.333h5.593"
          stroke="#fff"
          stroke-linecap="round"
        ></path>
      </g>
      <defs>
        <clippath id="db1b6__a">
          <path d="M0 0h16v16H0z" fill="#fff"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="qierujiaodu" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#db1b8__a)">
        <circle
          stroke-width="1.33"
          stroke="#FFAD0D"
          fill="#FFAD0D"
          r="7"
          cy="8"
          cx="8"
          data-follow-stroke="#FFAD0D"
        ></circle>
        <path
          fill="#fff"
          d="M12.195 8.658a1 1 0 0 0 0-1.414L9.66 4.708c-.63-.63-1.707-.183-1.707.708V7H4a1 1 0 0 0 0 2h3.953v1.487c0 .89 1.077 1.337 1.707.707l2.535-2.536Z"
          clip-rule="evenodd"
          fill-rule="evenodd"
        ></path>
      </g>
      <defs>
        <clippath id="db1b8__a">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="chuangyicankao" viewBox="0 0 16 16" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#FFAD0D"
        fill="#FFAD0D"
        d="M13.333 6.667a5.335 5.335 0 0 1-3.415 4.978H6.081A5.335 5.335 0 0 1 8 1.333a5.333 5.333 0 0 1 5.333 5.334Z"
        data-follow-fill="#FFAD0D"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#FFAD0D"
        d="m9.919 11.645-.227 2.716a.333.333 0 0 1-.332.306H6.64a.333.333 0 0 1-.332-.306l-.226-2.716"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#fff"
        d="M6 5.667v2l2-1 2 1v-2"
      ></path>
    </symbol>
    <symbol id="guanjiancimaidian" viewBox="0 0 16 16" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#7C48EE"
        d="M14 2.667H2a.667.667 0 0 0-.667.666v9.334c0 .368.299.666.667.666h12a.667.667 0 0 0 .667-.666V3.333A.667.667 0 0 0 14 2.667Z"
        data-follow-stroke="#7C48EE"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#7C48EE"
        fill="#7C48EE"
        d="M1.333 3.333c0-.368.299-.666.667-.666h12c.368 0 .667.298.667.666v2H1.333v-2Z"
        data-follow-fill="#7C48EE"
        data-follow-stroke="#7C48EE"
      ></path>
      <path
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#7C48EE"
        d="m8.333 7.667-.667 3.666"
        data-follow-stroke="#7C48EE"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#7C48EE"
        d="m10.334 7.667 2 1.666-2 2M5.667 7.667l-2 1.666 2 2"
        data-follow-stroke="#7C48EE"
      ></path>
    </symbol>
    <symbol id="mubiaorenqunhuaxiang" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="currentColor"
        d="M8 2a6 6 0 1 0 6 6"
      ></path>
      <path
        data-follow-stroke="currentColor"
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="currentColor"
        d="M8 5a3 3 0 1 0 3 3M8 8l2.1-2.102"
      ></path>
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        stroke-linejoin="round"
        stroke-width="1.333"
        stroke="currentColor"
        fill="currentColor"
        d="M10.1 3.809V5.9h2.109L14 4.1h-2.099V2l-1.8 1.809Z"
      ></path>
    </symbol>
    <symbol id="xiazai" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        d="M2 8.003V14h12V8"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
      <path
        data-follow-stroke="currentColor"
        d="m11 7.667-3 3-3-3M7.997 2v8.667"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="tubiao" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        d="M14 2.667H2a.667.667 0 0 0-.667.666v9.334c0 .368.299.666.667.666h12a.667.667 0 0 0 .667-.666V3.333A.667.667 0 0 0 14 2.667Zm-3.333 5.666v2.334M8 5.333v5.334m-2.667-4v4"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="shiyongchangjing" viewBox="0 0 16 16" fill="none">
      <g
        clip-path="url(#ddf5d__a)"
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#52C41A"
        fill="#52C41A"
        data-follow-stroke="#52C41A"
      >
        <path
          d="M8.024 1.31 5.667 3.667l2.357 2.357 2.357-2.357L8.024 1.31Zm4.333 4.333L10 8l2.357 2.357L14.714 8l-2.357-2.357Zm-8.667 0L1.333 8l2.357 2.357L6.047 8 3.69 5.643Zm4.334 4.333-2.357 2.357 2.357 2.357 2.357-2.357-2.357-2.357Z"
        ></path>
      </g>
      <defs>
        <clippath id="ddf5d__a">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="weimanzuxuqiu" viewBox="0 0 16 16" fill="none">
      <g
        clip-path="url(#ddf5e__a)"
        stroke-linejoin="round"
        stroke-width="1.333"
      >
        <path
          stroke="#F03D3D"
          fill="#F03D3D"
          d="M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334Z"
        ></path>
        <path
          stroke-linecap="round"
          stroke="#fff"
          d="M10.334 11.667S9.667 10.333 8 10.333a2.648 2.648 0 0 0-2.333 1.334M11.666 6l-2.333-.333M11 6v3M6.666 5.667 4.333 6M5 6v3"
        ></path>
      </g>
      <defs>
        <clippath id="ddf5e__a">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="hexinxuqiu" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        d="M3.334 14.667h9.333a.667.667 0 0 0 .667-.667V4.667L10 1.333H3.334A.667.667 0 0 0 2.667 2v12c0 .368.298.667.667.667Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
      <path
        d="m8 6.333.84 1.843 2.013.23-1.492 1.37.402 1.984L8 10.764l-1.764.996.403-1.984-1.493-1.37 2.013-.23.84-1.843Z"
        fill="#fff"
        stroke="#fff"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="xiaogougou" viewBox="0 0 22 22" fill="none">
      <circle
        data-follow-stroke="currentColor"
        cx="9.35"
        cy="11.602"
        r="8.35"
        stroke="currentColor"
        stroke-width="2"
      ></circle>
      <path
        data-follow-fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m4 10.25 2.083-2.083 4.167 4.166L18.583 4l2.084 2.083L10.25 16.5 4 10.25Z"
        fill="currentColor"
      ></path>
    </symbol>
    <symbol id="xiaoliangbianhuaqushi" viewBox="0 0 16 16" fill="none">
      <path
        stroke-linejoin="round"
        stroke-width="1.333"
        stroke="#FFAD0D"
        fill="#FFAD0D"
        d="M13 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Z"
        data-follow-fill="#FFAD0D"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#fff"
        d="m4.48 9.945 1.885-1.886 1.463 1.46L11.333 6"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#fff"
        d="M8.667 6h2.667v2.667"
      ></path>
    </symbol>
    <symbol id="zhengfuxiangqinggan" viewBox="0 0 16 16" fill="none">
      <g
        clip-path="url(#ddf62__a)"
        stroke-linejoin="round"
        stroke-width="1.333"
      >
        <path
          stroke="#FF7A25"
          fill="#FF7A25"
          d="M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334Z"
        ></path>
        <path
          stroke-linecap="round"
          stroke="#fff"
          d="M6.667 6.667 8 5.333l1.334 1.334M6.667 9.333 8 10.667l1.334-1.334"
        ></path>
      </g>
      <defs>
        <clippath id="ddf62__a">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="pingjiafenxi" viewBox="0 0 16 16" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#4DD3FD"
        fill="#4DD3FD"
        d="M14.666 2H1.333v10h3v1.667L7.666 12h7V2Z"
        data-follow-fill="#4DD3FD"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#fff"
        d="M4.667 6.5v1M8 6.5v1m3.333-1v1"
      ></path>
    </symbol>
    <symbol id="excel-a1gl2la3" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M8 15V6a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-9"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M31 15h3m-6 8h6m-6 8h6"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        fill="currentColor"
        d="M4 15h18v18H4z"
        data-follow-fill="currentColor"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="#FFF"
        d="m10 21 6 6m0-6-6 6"
      ></path>
    </symbol>
    <symbol id="excel" viewBox="0 0 16 16" fill="none">
      <g stroke-width="1.333" stroke-linecap="round" clip-path="url(#df211__a)">
        <path
          data-follow-stroke="currentColor"
          d="M4.5 5.75V3.5c0-.276.28-.5.625-.5h8.75c.345 0 .625.224.625.5v9c0 .276-.28.5-.625.5h-8.75c-.345 0-.625-.224-.625-.5v-2.25"
          stroke="currentColor"
          stroke-linejoin="round"
        ></path>
        <path
          data-follow-stroke="currentColor"
          d="M11.5 5.5h1M9.5 8h3m-3 2.5h3"
          stroke="currentColor"
        ></path>
        <path
          data-follow-stroke="currentColor"
          data-follow-fill="currentColor"
          d="m9.5 1.5-8 .929V13.57l8 .929v-13Z"
          fill="currentColor"
          stroke="currentColor"
          stroke-linejoin="round"
        ></path>
        <path
          d="m3.5 6 4 4m0-4-4 4"
          stroke="#fff"
          stroke-linejoin="round"
        ></path>
      </g>
      <defs>
        <clippath id="df211__a">
          <path d="M0 0h16v16H0z" fill="#fff"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="huihua-mian" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        d="M14.667 2H1.333v10h7l3.334 1.667V12h3V2Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
      <path
        d="M4.333 7.667S5.667 9 8 9c2.333 0 3.667-1.333 3.667-1.333"
        stroke="#fff"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="paimingNo3" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#e06eb__a)">
        <g filter="url(#e06eb__b)">
          <path fill="#E49C51" d="M4 18h16v3H4z"></path>
        </g>
        <path
          fill="url(#e06eb__c)"
          d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v15.56a2 2 0 0 1-2.392 1.962l-7.216-1.444a2.003 2.003 0 0 0-.784 0l-7.216 1.444A2 2 0 0 1 2 19.56V4Z"
        ></path>
        <g filter="url(#e06eb__d)">
          <path
            fill="#fff"
            d="M14.956 11.339c.09.385.136.782.136 1.19a5.206 5.206 0 0 1-.527 2.363 3.758 3.758 0 0 1-1.462 1.649c-.635.397-1.36.595-2.176.595-.816 0-1.502-.21-2.057-.629-.544-.43-.895-1.009-1.054-1.734a3.754 3.754 0 0 1-.085-.884c0-.215.006-.38.017-.493.023-.136.102-.204.238-.204h1.53c.136 0 .193.068.17.204-.023.329-.006.618.051.867.057.363.204.652.442.867.25.204.567.306.952.306.725 0 1.27-.34 1.632-1.02.17-.317.295-.742.374-1.275.023-.25.034-.43.034-.544 0-.363-.04-.657-.119-.884-.215-.635-.669-.952-1.36-.952a.863.863 0 0 0-.357.085c-.113.057-.26.142-.442.255a.273.273 0 0 1-.119.034c-.068 0-.119-.034-.153-.102l-.629-1.088a.274.274 0 0 1-.034-.119c0-.057.028-.113.085-.17l3.06-2.754c.023-.023.028-.045.017-.068 0-.023-.017-.034-.051-.034H8.938a.184.184 0 0 1-.136-.051.184.184 0 0 1-.034-.153l.17-1.292c0-.057.023-.102.068-.136a.211.211 0 0 1 .153-.068h6.579c.057 0 .102.023.136.068.034.034.045.08.034.136l-.187 1.479a.488.488 0 0 1-.119.255l-2.669 2.448c-.045.045-.028.08.051.102 1.009.147 1.666.731 1.972 1.751Z"
          ></path>
        </g>
      </g>
      <defs>
        <filter
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="11"
          width="24"
          y="14"
          x="0"
          id="e06eb__b"
        >
          <feflood result="BackgroundImageFix" flood-opacity="0"></feflood>
          <feblend
            result="shape"
            in2="BackgroundImageFix"
            in="SourceGraphic"
          ></feblend>
          <fegaussianblur
            result="effect1_foregroundBlur_2767_47782"
            stdDeviation="2"
          ></fegaussianblur>
        </filter>
        <filter
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="16.036"
          width="12.194"
          y="4.1"
          x="5.731"
          id="e06eb__d"
        >
          <feflood result="BackgroundImageFix" flood-opacity="0"></feflood>
          <fecolormatrix
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            in="SourceAlpha"
          ></fecolormatrix>
          <feoffset dy="1"></feoffset>
          <fegaussianblur stdDeviation="1"></fegaussianblur>
          <fecomposite operator="out" in2="hardAlpha"></fecomposite>
          <fecolormatrix
            values="0 0 0 0 0.894118 0 0 0 0 0.611765 0 0 0 0 0.317647 0 0 0 1 0"
          ></fecolormatrix>
          <feblend
            result="effect1_dropShadow_2767_47782"
            in2="BackgroundImageFix"
          ></feblend>
          <feblend
            result="shape"
            in2="effect1_dropShadow_2767_47782"
            in="SourceGraphic"
          ></feblend>
        </filter>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="22"
          x2="12"
          y1="2"
          x1="12"
          id="e06eb__c"
        >
          <stop stop-color="#FFD49F"></stop>
          <stop stop-color="#FCB56B" offset="1"></stop>
        </lineargradient>
        <clippath id="e06eb__a">
          <path fill="#fff" d="M0 0h24v24H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="paimingNo2" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#e06ec__a)">
        <g filter="url(#e06ec__b)">
          <path fill="#96ACCD" d="M4 18h16v3H4z"></path>
        </g>
        <path
          fill="url(#e06ec__c)"
          d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v15.56a2 2 0 0 1-2.392 1.962l-7.216-1.444a2.003 2.003 0 0 0-.784 0l-7.216 1.444A2 2 0 0 1 2 19.56V4Z"
        ></path>
        <g filter="url(#e06ec__d)">
          <path
            fill="#fff"
            d="M10.264 15.198c-.023.023-.034.045-.034.068.011.023.034.034.068.034h4.692c.057 0 .102.023.136.068.034.034.045.08.034.136l-.153 1.292a.296.296 0 0 1-.085.153.184.184 0 0 1-.136.051H7.697a.184.184 0 0 1-.136-.051.184.184 0 0 1-.034-.153l.136-1.224a.437.437 0 0 1 .136-.255c.68-.646 1.78-1.768 3.298-3.366l.918-.952c1.156-1.213 1.774-2.13 1.853-2.754.057-.465-.057-.844-.34-1.139-.283-.295-.68-.442-1.19-.442-.51 0-.94.147-1.292.442-.34.295-.538.686-.595 1.173l-.068.442a.212.212 0 0 1-.068.153.248.248 0 0 1-.153.051h-1.53a.184.184 0 0 1-.136-.051.184.184 0 0 1-.034-.153l.085-.731A3.248 3.248 0 0 1 9.89 5.797c.748-.555 1.638-.833 2.669-.833.669 0 1.247.125 1.734.374.499.238.878.572 1.139 1.003.26.42.391.895.391 1.428 0 1.088-.618 2.306-1.853 3.655-.657.748-1.677 1.79-3.06 3.128l-.646.646Z"
          ></path>
        </g>
      </g>
      <defs>
        <filter
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="11"
          width="24"
          y="14"
          x="0"
          id="e06ec__b"
        >
          <feflood result="BackgroundImageFix" flood-opacity="0"></feflood>
          <feblend
            result="shape"
            in2="BackgroundImageFix"
            in="SourceGraphic"
          ></feblend>
          <fegaussianblur
            result="effect1_foregroundBlur_2767_47783"
            stdDeviation="2"
          ></fegaussianblur>
        </filter>
        <filter
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="16.036"
          width="12.313"
          y="3.964"
          x="5.51"
          id="e06ec__d"
        >
          <feflood result="BackgroundImageFix" flood-opacity="0"></feflood>
          <fecolormatrix
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            in="SourceAlpha"
          ></fecolormatrix>
          <feoffset dy="1"></feoffset>
          <fegaussianblur stdDeviation="1"></fegaussianblur>
          <fecomposite operator="out" in2="hardAlpha"></fecomposite>
          <fecolormatrix
            values="0 0 0 0 0.526736 0 0 0 0 0.608167 0 0 0 0 0.683333 0 0 0 0.78 0"
          ></fecolormatrix>
          <feblend
            result="effect1_dropShadow_2767_47783"
            in2="BackgroundImageFix"
          ></feblend>
          <feblend
            result="shape"
            in2="effect1_dropShadow_2767_47783"
            in="SourceGraphic"
          ></feblend>
        </filter>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="22"
          x2="12"
          y1="2"
          x1="12"
          id="e06ec__c"
        >
          <stop stop-color="#DDE3ED"></stop>
          <stop stop-color="#B2BFD7" offset="1"></stop>
        </lineargradient>
        <clippath id="e06ec__a">
          <path fill="#fff" d="M0 0h24v24H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="paimingNo1" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#e06ed__a)">
        <g filter="url(#e06ed__b)">
          <path fill="#F8C881" d="M4 18h16v3H4z"></path>
        </g>
        <path
          fill="url(#e06ed__c)"
          d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v15.56a2 2 0 0 1-2.392 1.962l-7.216-1.444a2.003 2.003 0 0 0-.784 0l-7.216 1.444A2 2 0 0 1 2 19.56V4Z"
        ></path>
        <g filter="url(#e06ed__d)">
          <path
            fill="#fff"
            d="M11.757 5.151a.64.64 0 0 1 .255-.051h1.581c.125 0 .187.068.187.204l-1.411 11.492a.296.296 0 0 1-.085.153.248.248 0 0 1-.153.051h-1.513a.184.184 0 0 1-.136-.051c-.034-.045-.045-.096-.034-.153l1.19-9.656c0-.068-.034-.09-.102-.068l-1.7.527a.19.19 0 0 1-.085.017.163.163 0 0 1-.119-.051.192.192 0 0 1-.017-.136l.102-1.122a.24.24 0 0 1 .153-.238l1.887-.918Z"
          ></path>
        </g>
      </g>
      <defs>
        <filter
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="11"
          width="24"
          y="14"
          x="0"
          id="e06ed__b"
        >
          <feflood result="BackgroundImageFix" flood-opacity="0"></feflood>
          <feblend
            result="shape"
            in2="BackgroundImageFix"
            in="SourceGraphic"
          ></feblend>
          <fegaussianblur
            result="effect1_foregroundBlur_2767_47784"
            stdDeviation="2"
          ></fegaussianblur>
        </filter>
        <filter
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
          height="15.9"
          width="8.182"
          y="4.1"
          x="7.598"
          id="e06ed__d"
        >
          <feflood result="BackgroundImageFix" flood-opacity="0"></feflood>
          <fecolormatrix
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            in="SourceAlpha"
          ></fecolormatrix>
          <feoffset dy="1"></feoffset>
          <fegaussianblur stdDeviation="1"></fegaussianblur>
          <fecomposite operator="out" in2="hardAlpha"></fecomposite>
          <fecolormatrix
            values="0 0 0 0 0.866667 0 0 0 0 0.468 0 0 0 0 0 0 0 0 0.78 0"
          ></fecolormatrix>
          <feblend
            result="effect1_dropShadow_2767_47784"
            in2="BackgroundImageFix"
          ></feblend>
          <feblend
            result="shape"
            in2="effect1_dropShadow_2767_47784"
            in="SourceGraphic"
          ></feblend>
        </filter>
        <lineargradient
          gradientUnits="userSpaceOnUse"
          y2="22"
          x2="12"
          y1="2"
          x1="12"
          id="e06ed__c"
        >
          <stop stop-color="#FFD25F"></stop>
          <stop stop-color="#F7AC3C" offset="1"></stop>
        </lineargradient>
        <clippath id="e06ed__a">
          <path fill="#fff" d="M0 0h24v24H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="diamonds" viewBox="0 0 48 48" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        fill="currentColor"
        d="M12 8h24l8 10-20 24L4 18l8-10Z"
        data-follow-fill="currentColor"
        data-follow-stroke="currentColor"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="#FFF"
        d="M4 18h40M24 42l-8-24m8 24 8-24"
      ></path>
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="m8 13-4 5 20 24 20-24-4-5"
        data-follow-stroke="currentColor"
      ></path>
    </symbol>
    <symbol id="chanpinshengliang" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#e111d__a)" stroke-width="1.333">
        <path
          stroke="#3067F2"
          fill="#3067F2"
          d="M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334Z"
        ></path>
        <path
          stroke-linecap="round"
          stroke="#fff"
          d="M10 6v4m2-2.667v1.334M6 6v4M4 7.333v1.334m4-4v6.666"
        ></path>
      </g>
      <defs>
        <clippath id="e111d__a">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clippath>
      </defs>
    </symbol>
    <symbol id="pinpairedian" viewBox="0 0 16 16" fill="none">
      <path
        fill="#307DFF"
        d="m5.623 11.015-.29 3.886c-.021.273.222.462.439.34 1.537-.861 6.354-4.025 8.795-10.978.112-.319-.189-.606-.446-.426-1.442 1.01-4.593 3.097-6.54 3.494 0 0 1.247-.866 1.993-2.196a.4.4 0 0 0-.014-.415L6.837.796c-.161-.232-.492-.136-.55.16L5.439 5.27 1.461 8.741c-.2.174-.159.526.072.619l4.09 1.655Zm7.035-1.532c-.252.351-.795 1.074-1.296 1.516a.19.19 0 0 0 .028.309l2.648 1.662c.16.1.374-.019.348-.193-.124-.794-.478-2.45-1.375-3.319-.1-.097-.273-.087-.353.025Z"
        clip-rule="evenodd"
        fill-rule="evenodd"
        data-follow-fill="#307DFF"
      ></path>
    </symbol>
    <symbol id="shouzhongfenxi" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-fill="currentColor"
        d="M14.469 2.563h-13a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5ZM13.027 5.6l-4.641 4.644a.125.125 0 0 1-.177 0L6.42 8.454l-2.695 2.698a.126.126 0 0 1-.177 0l-.575-.575a.126.126 0 0 1 0-.177l3.358-3.36a.125.125 0 0 1 .177 0l1.789 1.788 3.976-3.978a.125.125 0 0 1 .177 0l.575.575c.05.047.05.127.002.175Z"
        fill="currentColor"
      ></path>
    </symbol>
    <symbol id="c-down" viewBox="0 0 48 48" fill="none">
      <path
        data-follow-fill="currentColor"
        fill-opacity=".01"
        fill="currentColor"
        d="M0 0h48v48H0z"
      ></path>
      <path
        data-follow-stroke="currentColor"
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="4"
        stroke="currentColor"
        d="M37 18 25 30 13 18"
      ></path>
    </symbol>
    <symbol id="c-right" viewBox="0 0 48 48" fill="none">
      <path
        data-follow-fill="currentColor"
        d="M0 0h48v48H0z"
        fill="currentColor"
        fill-opacity=".01"
      ></path>
      <path
        data-follow-stroke="currentColor"
        d="m19 12 12 12-12 12"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="pinpaiyuqing" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-fill="currentColor"
        d="M14.075 3.877 8.533.677a1.073 1.073 0 0 0-1.066 0l-5.542 3.2c-.33.19-.533.544-.533.923v6.4c0 .381.203.733.533.923l5.542 3.2c.33.189.736.189 1.066 0l5.542-3.2c.33-.19.533-.544.533-.923V4.8c0-.381-.203-.733-.533-.923ZM12.763 6.04l-4.23 2.355v4.848c0 .293-.24.533-.533.533a.535.535 0 0 1-.533-.533V8.395L3.237 6.04a.533.533 0 0 1 .52-.93L8 7.471l4.245-2.365a.534.534 0 0 1 .518.933Z"
        fill="currentColor"
      ></path>
    </symbol>
    <symbol id="wendangxiangqing" viewBox="0 0 16 16" fill="none">
      <path
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="1.333"
        stroke="#999"
        d="M1 2.67h14v10h-4.577L8 14.67l-2.423-2H1v-10Z"
        data-follow-stroke="#999"
      ></path>
      <path
        stroke-linecap="round"
        stroke-width="1.33"
        stroke="#999"
        d="M4 5.8h8m-8 3h4"
        data-follow-stroke="#999"
      ></path>
    </symbol>
    <symbol id="duibi" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        d="M8 2.333H2.333v11.334H8V2.333Z"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linejoin="round"
      ></path>
      <path
        data-follow-stroke="currentColor"
        d="M8 2.333h1.333m1.667 0h.667M11 13.667h.667m2-11.334V3m0 2v.667m0 2v.666m0 2V11m0 2v.667m-4.667 0H8M8 1.333v13.334"
        stroke="currentColor"
        stroke-width="1.333"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="pinleidapan" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        d="M14 8a6 6 0 1 1-6-6v6h6Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.33"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        d="M14 6h-4V2a6.128 6.128 0 0 1 4 4Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.33"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="pinpai" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m9.754 14.05 4.302-4.302a1.2 1.2 0 0 0 0-1.692l-5.39-5.39h-6v6l5.39 5.384a1.2 1.2 0 0 0 1.698 0ZM8.727 6.545a2.182 2.182 0 1 1-4.363 0 2.182 2.182 0 0 1 4.363 0Z"
        fill="currentColor"
      ></path>
      <path
        data-follow-fill="currentColor"
        d="m14.056 9.748.707.708.002-.003-.709-.705ZM9.754 14.05l-.707-.707.707.707Zm4.302-5.994.71-.705-.003-.002-.707.707Zm-5.39-5.39.708-.706a1 1 0 0 0-.707-.293v1Zm-6 0v-1a1 1 0 0 0-1 1h1Zm0 6h-1a1 1 0 0 0 .294.708l.707-.707Zm5.39 5.384.708-.706-.001-.001-.707.707Zm5.293-5.009-4.302 4.302 1.414 1.415 4.302-4.302L13.35 9.04Zm-.002-.28a.2.2 0 0 1 0 .282l1.418 1.41a2.2 2.2 0 0 0 0-3.102l-1.418 1.41ZM7.96 3.374l5.39 5.39 1.413-1.415-5.39-5.39L7.96 3.375Zm-5.293.293h6v-2h-6v2Zm1 5v-6h-2v6h2Zm5.096 4.676-5.39-5.384L1.96 9.374l5.39 5.384 1.413-1.415Zm.142.06a.2.2 0 0 1-.141-.06l-1.415 1.414a2.2 2.2 0 0 0 1.556.645v-2Zm.142-.06a.2.2 0 0 1-.142.06v2a2.2 2.2 0 0 0 1.557-.646l-1.415-1.413ZM6.545 9.728a3.182 3.182 0 0 0 3.182-3.182h-2c0 .653-.529 1.182-1.182 1.182v2ZM3.364 6.545a3.182 3.182 0 0 0 3.181 3.182v-2a1.182 1.182 0 0 1-1.181-1.182h-2Zm3.181-3.181a3.182 3.182 0 0 0-3.181 3.181h2c0-.652.529-1.181 1.181-1.181v-2Zm3.182 3.181a3.182 3.182 0 0 0-3.182-3.181v2c.653 0 1.182.529 1.182 1.181h2Z"
        fill="currentColor"
      ></path>
    </symbol>
    <symbol id="meiriredian" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        d="M8 14.667c2.745 0 5-2.176 5-4.968 0-.685-.035-1.42-.415-2.562s-.456-1.29-.858-1.994c-.172 1.439-1.09 2.039-1.323 2.218 0-.187-.556-2.249-1.398-3.483-.827-1.211-1.952-2.006-2.61-2.545 0 1.024-.289 2.545-.7 3.32-.413.775-.49.804-1.005 1.38-.515.577-.751.755-1.182 1.455C3.08 8.188 3 9.121 3 9.806c0 2.792 2.255 4.86 5 4.86Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.33"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="pinpaiyuqing-a8a530n6" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.133 6.475c0-2.913 2.687-5.275 6-5.275 3.314 0 6 2.362 6 5.275v6.858h.667a.667.667 0 0 1 0 1.334H1.2a.667.667 0 0 1 0-1.334h.933V6.475ZM8.331 4.62c.32.183.432.591.249.912l-1.029 1.8h2.05a.668.668 0 0 1 .579 1l-1.6 2.8a.668.668 0 1 1-1.16-.663l1.029-1.8H6.4a.668.668 0 0 1-.58-1l1.6-2.8a.668.668 0 0 1 .911-.249Z"
        fill="currentColor"
      ></path>
    </symbol>
    <symbol id="jingpinduibi" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-fill="currentColor"
        d="M5.878 11.744c-.12.102-.307.192-.563.269-.247.077-.52.115-.82.115a2.48 2.48 0 0 1-.92-.154c-.257-.11-.432-.26-.525-.448-.094-.196-.21-.448-.346-.755a41.341 41.341 0 0 1-.435-1.05l-.461-1.215A59.71 59.71 0 0 1 .95 5.882a26.953 26.953 0 0 1-.332-1.204 1.6 1.6 0 0 1 .512-.32 1.78 1.78 0 0 1 .73-.153c.315 0 .57.068.767.205.205.128.354.37.448.73.23.835.46 1.638.691 2.406.24.76.487 1.553.743 2.38h.077c.23-.802.465-1.676.704-2.624.247-.947.482-1.89.704-2.828.153-.077.315-.141.486-.192.18-.052.38-.077.602-.077.315 0 .584.072.806.217.222.137.333.367.333.692 0 .187-.047.46-.141.819-.085.358-.2.764-.346 1.216a26.54 26.54 0 0 1-.473 1.395c-.17.486-.346.947-.525 1.382-.17.427-.333.807-.486 1.14a4.61 4.61 0 0 1-.372.678Zm5.731-2.829a16.597 16.597 0 0 1-1.024-.384 3.284 3.284 0 0 1-.794-.486 2.087 2.087 0 0 1-.525-.666c-.12-.264-.18-.584-.18-.96 0-.725.278-1.305.833-1.74.563-.436 1.348-.653 2.355-.653.367 0 .708.025 1.024.076.316.052.585.133.807.244.23.102.41.239.537.41a.902.902 0 0 1 .192.575c0 .222-.051.414-.153.576a1.644 1.644 0 0 1-.372.397 2.766 2.766 0 0 0-.755-.307 3.627 3.627 0 0 0-1.037-.141c-.384 0-.665.055-.844.166-.18.103-.27.235-.27.397a.39.39 0 0 0 .167.32c.111.077.277.15.5.218l.678.217c.802.256 1.416.585 1.843.986.435.393.653.93.653 1.613 0 .725-.286 1.314-.858 1.766-.572.444-1.412.666-2.521.666a5.55 5.55 0 0 1-1.101-.103 3.58 3.58 0 0 1-.883-.268 1.817 1.817 0 0 1-.59-.461 1.06 1.06 0 0 1-.204-.64c0-.248.072-.457.218-.627a1.62 1.62 0 0 1 .473-.41c.24.188.53.35.87.486a3.1 3.1 0 0 0 1.14.205c.418 0 .712-.064.883-.192.17-.128.256-.277.256-.448a.423.423 0 0 0-.205-.384 2.446 2.446 0 0 0-.576-.269l-.537-.179Z"
        fill="currentColor"
      ></path>
    </symbol>
    <symbol id="pinlei" viewBox="0 0 16 16" fill="none">
      <path
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        d="M6 2H2.667A.667.667 0 0 0 2 2.667V6c0 .368.298.667.667.667H6A.667.667 0 0 0 6.667 6V2.667A.667.667 0 0 0 6 2Zm0 7.333H2.667A.667.667 0 0 0 2 10v3.333c0 .368.298.667.667.667H6a.667.667 0 0 0 .667-.667V10A.667.667 0 0 0 6 9.333Zm5.667-2.666a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667Zm1.666 2.666H10a.667.667 0 0 0-.667.667v3.333c0 .368.299.667.667.667h3.333a.667.667 0 0 0 .667-.667V10a.667.667 0 0 0-.667-.667Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.667"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="lishi-mian" viewBox="0 0 16 16" fill="none">
      <circle
        data-follow-stroke="currentColor"
        data-follow-fill="currentColor"
        cx="8"
        cy="8"
        r="6.335"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.33"
      ></circle>
      <path
        d="M8 3.5V8H4.5"
        stroke="#fff"
        stroke-width="1.33"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
    <symbol id="lishi-xian" viewBox="0 0 16 16" fill="none">
      <circle
        data-follow-stroke="currentColor"
        cx="8"
        cy="8"
        r="6.335"
        stroke="currentColor"
        stroke-width="1.33"
      ></circle>
      <path
        data-follow-stroke="currentColor"
        d="M8 3.5V8H4.5"
        stroke="currentColor"
        stroke-width="1.33"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </symbol>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>